import { ReactNode } from 'react';

import { useIntl } from 'react-intl';

interface IToastNotificationContentProps {
  icon: ReactNode;
  text: string;
  subtext?: string;
}

const ToastNotificationContent = ({ icon, text, subtext }: IToastNotificationContentProps) => {
  const { formatMessage } = useIntl();
  return (
    <div className="d-flex align-items-center">
      <span className="ms-3 me-3 d-flex">{icon}</span>
      <div data-test={`toast-notification-content-${text}`}>
        <p className="mb-0">{formatMessage({ id: text })}</p>
        {subtext && <b data-test="toast-notification-subtext">{subtext}</b>}
      </div>
    </div>
  );
};

export default ToastNotificationContent;
